export * from './slider.module';
export * from './slider.component';
export * from './slider-cnob.component';
export * from './types';
